const REVIEWS_HELP_PATH = 'pacientu_kak_my_proveryaem_otzyvy/'

/**
 * Ссылка на статью «Как мы проверяем отзывы?» с учётом страны.
 *
 * Для России (и пустого ISO) всегда `help.prodoctorov.ru`.
 * Для остальных стран — `help.ydoc.me` без префикса страны в пути:
 * на help-поддомене локаль задаётся хостом, а не сегментом URL.
 */
export default function getReviewsHelpUrl(countryIso: string, isRussia: boolean): string {
  if (isRussia) {
    return `https://help.prodoctorov.ru/${REVIEWS_HELP_PATH}`
  }

  const country = countryIso.toLowerCase()

  if (country === 'ru' || !country) {
    return `https://help.prodoctorov.ru/${REVIEWS_HELP_PATH}`
  }

  return `https://help.ydoc.me/${REVIEWS_HELP_PATH}`
}
